import {
    useLocation,
    Navigate,
    Outlet
} from "react-router-dom";
import { DASHBOARD_ROLES } from "routes/roles";

// Read on every render, not kept in state: switching company rewrites rUser and the guard must follow.
const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation();
    const role = localStorage.getItem('rUser');
    const hasToken = !!localStorage.getItem('xsrfToken');

    if (allowedRoles?.includes(role)) return <Outlet />;
    // A role the dashboard itself refuses (missing or non-company rUser) would loop on /dashboard.
    if (hasToken) return DASHBOARD_ROLES.includes(role)
        ? <Navigate to="/dashboard" replace />
        : <Navigate to="/unauthorized" state={{ from: location }} replace />;
    window.location.href = process.env.REACT_APP_COMPANY_LOGIN + '?redirect=' + encodeURIComponent(location.pathname);
    return null;
}

export default RequireAuth;
